import { render, staticRenderFns } from "./DbGisBoxSettings.vue?vue&type=template&id=b255fb2c&"
import script from "./DbGisBoxSettings.vue?vue&type=script&lang=js&"
export * from "./DbGisBoxSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports